<app-header class="header-fixed" *ngIf="appLoaded"></app-header>

<app-menu-sidebar *ngIf="appLoaded" class=""></app-menu-sidebar>

<div class="content-container">
    <div *ngIf="appLoaded" class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>

<app-footer class="footer-fixed" *ngIf="appLoaded"></app-footer>
<!-- <app-control-sidebar *ngIf="appLoaded"></app-control-sidebar> -->

<div id="sidebar-overlay" *ngIf="appLoaded" (click)="onToggleMenuSidebar()"></div>

<!-- <app-loading *ngIf="!appLoaded"></app-loading> -->
